<template>
  <nav class="navbar header is-white is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="container">
      <div class="navbar-brand">
        <div class="navbar-item">
          <router-link class="navbar-item" :to="{ name: 'home' }">
            <img src="../../assets/logo.png" />
            <b class="is-size-6" style=" padding-top:5px;">{{ $t('title.onlineInternalAudit') }}</b>
          </router-link>
        </div>
        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          @click="isOpen = !isOpen"
          v-bind:class="{ 'is-active': isOpen }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active': isOpen }">
        <div class="navbar-start"></div>

        <div class="navbar-end">
          <!-- <div class="navbar-item" v-if="isAuthenticated && role.limited">
            <router-link class="button is-success" :to="{ name: 'payment' }">
              <span>{{ $tc('button.goToPremium') }}</span>
            </router-link>
          </div>-->
          <div class="navbar-item" v-if="isAuthenticated">
            <a @click="onClickProcess" class="button is-primary">
              <strong>{{ $t('button.selectProcess') }}</strong>
            </a>
          </div>
          <div
            ref="userMenu"
            class="navbar-item has-dropdown"
            :class="{ 'is-hoverable': !isTouch, 'is-active': isUserMenuOpen }"
            v-if="isAuthenticated"
            @pointerenter="isTouch = $event.pointerType !== 'mouse'"
          >
            <a class="navbar-link" @click="onClickUserName"
              >{{ currentUser.firstname }} {{ currentUser.lastname }}</a
            >
            <div
              class="navbar-dropdown is-right"
              v-bind:style="{ maxHeight: navbarMaxHeight + 'px', overflow: 'auto' }"
              @click="onClickUserMenu"
            >
              <span class="navbar-item">
                <b-button :type="badge.type" expanded>
                  {{ badge.label ? $t(badge.label) : badge.text }}
                </b-button>
              </span>
              <template v-for="(group, index) in menu">
                <hr v-if="index > 0" class="navbar-divider" :key="`divider-${group.key}`" />
                <span v-if="group.title" class="navbar-item" :key="`title-${group.key}`">
                  <b>{{ $t(group.title) }}</b>
                </span>
                <menu-link
                  v-for="item in group.items"
                  :key="item.route || item.href"
                  :item="item"
                  class="navbar-item"
                >
                  <span class="icon is-medium">
                    <i :class="`fas fa-${item.icon}`"></i>
                  </span>
                  <span>{{ label(item) }}</span>
                </menu-link>
              </template>
              <hr class="navbar-divider" />
              <a class="navbar-item" @click="onLogout">
                <span class="icon is-medium">
                  <i class="fas fa-power-off"></i>
                </span>
                {{ $t('button.logout') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { LOGOUT } from '../../store/actions.type'
import { visibleMenu, membershipBadge } from '../../_helpers/menu'
import MenuLink from '../../components/MenuLink.vue'

export default {
  components: { MenuLink },
  data () {
    return {
      isOpen: false,
      // A touch leaves :hover stuck on the menu until the next tap elsewhere, so touch opens
      // it by tap instead. Read from the pointer, not (hover: none): pen tablets report hover.
      isTouch: false,
      isUserMenuOpen: false,
      navbarMaxHeight: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'isAuthenticated', 'role']),
    menu () {
      return visibleMenu({ role: this.role, currentUser: this.currentUser })
    },
    badge () {
      return membershipBadge({ role: this.role, currentUser: this.currentUser })
    }
  },
  watch: {
    // The mobile menu stays open across in-app navigation otherwise.
    $route () {
      this.closeMenus()
    }
  },
  mounted () {
    this.setNavbarHeight()
    window.addEventListener('resize', this.setNavbarHeight)
    document.addEventListener('pointerdown', this.onPointerDownOutside)
  },
  destroyed () {
    window.removeEventListener('resize', this.setNavbarHeight)
    document.removeEventListener('pointerdown', this.onPointerDownOutside)
  },
  methods: {
    label (item) {
      return item.label.map(key => this.$t(key)).join(' ')
    },
    closeMenus () {
      this.isOpen = false
      this.isUserMenuOpen = false
    },
    onClickUserName () {
      if (this.isTouch) this.isUserMenuOpen = !this.isUserMenuOpen
    },
    // Covers what the $route watcher cannot see: the current page, external links.
    onClickUserMenu (event) {
      if (event.target.closest('a')) this.closeMenus()
    },
    onPointerDownOutside (event) {
      if (this.isUserMenuOpen && !this.$refs.userMenu.contains(event.target)) {
        this.isUserMenuOpen = false
      }
    },
    onLogout () {
      this.$store.dispatch(LOGOUT).then(() => this.$router.push({ name: 'login' }))
    },
    onClickProcess () {
      if (this.$route.name === 'process') {
        window.location.href = `/${this.$t('routes.process')}`
      } else {
        this.$router.push({ name: 'process', params: { step: 1 } })
      }
    },
    setNavbarHeight () {
      this.navbarMaxHeight = window.innerHeight - this.convertRemToPixels(3.25)
    },
    convertRemToPixels (rem) {
      return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
    }
  }
}
</script>
<style scoped>
/* .dropdown-content {
  max-height: 13em;
  overflow: auto;
} */
</style>
